import React from 'react';
import ForgotPassword from '@features/auth/components/forgot-password/ForgotPassword';

const ForgotPasswordPage: React.FC = () => {
  return <ForgotPassword />;
};

export default ForgotPasswordPage;